// @flow
import React from 'react'
import PromotionItemCard, {
  type PropTypes as PromotionItemCardTypes,
} from 'components/molecules/PromotionListItem'

export type PropTypes = {
  promotionItemCardPropsList: Array<PromotionItemCardTypes>,
}

export default class PromotionListPage extends React.Component<*> {
  props: PropTypes
  render() {
    if (this.props.promotionItemCardPropsList.length == 0) return null
    return (
      <div className="container">
        <div className="page-xs12-head">
          <h1 className="page-title">{i18n.t('page.promotionList.title')}</h1>
          <p className="page-description">
            {i18n.t('page.promotionList.pageDescription')}
          </p>
        </div>
        <div className="row">
          {this.props.promotionItemCardPropsList.map(item => {
            const coupon = item.coupon || item.pointCode
            if (!coupon) return null
            return (
              <PromotionItemCard
                {...item}
                key={item.id}
                validAt={coupon.validAt}
                expiresAt={coupon.expiresAt}
              />
            )
          })}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/PromotionListPage/index.jsx